/** @format */

import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

const PREFIX = 'WidgetSwitcher';

const classes = {
  switcherBackground: `${PREFIX}-switcherBackground`,
  switcherThumb: `${PREFIX}-switcherThumb`,
  switcherThumbHover: `${PREFIX}-switcherThumbHover`,
};

interface RootProps {
  customColor: string;
  selected: boolean;
}

const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'customColor' && prop !== 'selected',
})<RootProps>(({theme, customColor: color, selected}) => ({
  '&.MuiButtonBase-root': {
    width: '38px',
    minWidth: 'auto',
    flexShrink: 0,
    height: '24px',
    border: 'none',
    borderRadius: theme.spacing(3),
    cursor: 'pointer',
    outline: 'none',
    position: 'relative',
    background: 'none',
    padding: 0,

    [`.${classes.switcherBackground}`]: {
      width: '100%',
      height: '100%',
      borderRadius: theme.spacing(3),
      transition: 'background-color 0.2s, opacity 0.2s',
      backgroundColor: selected ? color : '#A5A6AB',
      opacity: 0.2,
    },

    [`.${classes.switcherThumb}`]: {
      borderRadius: theme.spacing(2.5),
      width: '20px',
      height: '20px',
      position: 'absolute',
      top: '2px',
      right: selected ? '2px' : '16px',
      transition: 'background-color 0.2s, right 0.2s',
      backgroundColor: selected ? color : '#A5A6AB',
    },

    [`.${classes.switcherThumbHover}`]: {
      borderRadius: theme.spacing(2.5),
      width: '20px',
      height: '20px',
      position: 'absolute',
      left: 0,
      top: 0,
      background: theme.palette.secondary?.main,
      transition: 'opacity 0.2s',
      opacity: 0,
    },

    '&:hover': {
      [`.${classes.switcherBackground}`]: {
        opacity: 0.3,
      },
      [`.${classes.switcherThumbHover}`]: {
        opacity: 0.2,
      },
    },
  },
}));

export {Root as SwitcherRoot, classes as switcherClasses};
